export interface IUploadFilesCheckResult {
    message: string;
    fileNamesInUse: string[];
}

export class UploadFilesCheckResult implements IUploadFilesCheckResult {
    message: string;
    fileNamesInUse: string[];

    constructor();
    constructor(obj: IUploadFilesCheckResult);
    constructor(obj?: any) {
        this.message = obj && obj.message || "";
        this.fileNamesInUse = obj && obj.fileNamesInUse || [];
    }
}